module.exports = __webpack_public_path__ + "static/img/h10.f505f15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h10.jpg
// module id = U/0u
// module chunks = 0